import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { Property3DTourSectionComponent } from '../../../sections/property-default-sections/property-3d-tour-section/property-3d-tour-section.component';
import { PropertyPhotoSectionComponent } from '../../../sections/property-default-sections/property-photo-section/property-photo-section.component';
import { PropertyVideoSectionComponent } from '../../../sections/property-default-sections/property-video-section/property-video-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    selector: 'property-photos-page',
    templateUrl: './property-photos-page.component.html',
    styleUrls: ['./property-photos-page.component.scss'],
    standalone: false
})
export class PropertyPhotosPageComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyPhotoSectionComponent, {
        read: PropertyPhotoSectionComponent
    })
    propertyPhotoSectionComponent: PropertyPhotoSectionComponent;

    @ViewChild(PropertyVideoSectionComponent, {
        read: PropertyVideoSectionComponent
    })
    propertyVideoSectionComponent: PropertyVideoSectionComponent;

    @ViewChild(Property3DTourSectionComponent, {
        read: Property3DTourSectionComponent
    })
    property3DTourSectionComponent: Property3DTourSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyPhotos, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyPhotoSectionComponent);
        super.registerSection(this.propertyVideoSectionComponent);
        super.registerSection(this.property3DTourSectionComponent);
    }
}
